import React from "react";
import { IoCheckbox, IoCheckmarkDoneCircleOutline } from "react-icons/io5";

export default function Features({ VenuesDetails }) {
  return (
    <div className="details-section" style={{boxShadow:"0 0 5px 0 rgba(0,0,0,0.1)", background:"white", padding:"20px"}}>
      <h4>Features We Offer</h4>

      <div className="row" style={{ marginTop: 20 }}>
        {VenuesDetails?.features?.map((val, index) => (
          <div className="col-md-3" key={index}>
            <p className="d-flex align-items-center">
              <IoCheckmarkDoneCircleOutline style={{ color: "maroon", fontSize: 25 }} />
              <strong style={{ marginLeft: 5 }}>{val?.title}</strong>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
